/* IOELABS Obsidian — progressive enhancement; Shopify owns all order totals. */
(() => {
  'use strict';
  function init(root = document) {
    root.querySelectorAll('[data-product-section]').forEach(section => {
      if (section.dataset.initialized) return;
      section.dataset.initialized = 'true';
      const data = section.querySelector('[data-variant-data]');
      let variants = [];
      try { variants = JSON.parse(data?.textContent || '[]'); } catch (_) { return; }
      const select = section.querySelector('[data-variant-select]');
      const update = () => {
        const variant = variants.find(v => String(v.id) === select?.value);
        if (!variant) return;
        const price = section.querySelector('[data-variant-price]');
        const compare = section.querySelector('[data-variant-compare]');
        const button = section.querySelector('[data-add-button]');
        const label = section.querySelector('[data-add-label]');
        price.textContent = variant.price;
        compare.hidden = !variant.compare;
        compare.textContent = variant.compare || '';
        button.disabled = !variant.available;
        label.textContent = variant.available ? 'Añadir al carrito' : 'Agotado';
        const qty = section.querySelector('input[name="quantity"]');
        qty.min = variant.min || 1;
        qty.step = variant.step || 1;
        if (variant.max != null) qty.max = variant.max; else qty.removeAttribute('max');
        qty.value = variant.min || 1;
        if (variant.image) showImage(section, variant.image);
        const url = new URL(location.href);
        url.searchParams.set('variant', variant.id);
        history.replaceState({}, '', url);
      };
      select?.addEventListener('change', update);
      section.querySelectorAll('[data-gallery-thumb]').forEach(thumb => {
        thumb.addEventListener('click', event => {
          event.preventDefault();
          showImage(section, thumb.dataset.full);
          section.querySelectorAll('[data-gallery-thumb]').forEach(t => t.removeAttribute('aria-current'));
          thumb.setAttribute('aria-current', 'true');
        });
      });
    });
  }
  function showImage(section, url) {
    const img = section.querySelector('.product-main-image');
    if (!img) return;
    img.src = url;
    img.removeAttribute('srcset');
    section.querySelector('[data-main-image-link]')?.setAttribute('href', url);
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-quantity]');
    if (button) {
      const input = button.closest('.quantity')?.querySelector('input');
      if (!input) return;
      if (!Number.isFinite(Number(input.value)) || input.value === '') input.value = input.min || '1';
      try { if (Number(button.dataset.quantity) > 0) input.stepUp(); else input.stepDown(); } catch (_) { return; }
      input.dispatchEvent(new Event('change', {bubbles: true}));
    }
    if (event.target.closest('.mobile-nav a')) event.target.closest('.mobile-nav').removeAttribute('open');
    if (!event.target.closest('.mobile-nav')) document.querySelectorAll('.mobile-nav[open]').forEach(menu => menu.removeAttribute('open'));
  });
  document.addEventListener('change', event => {
    if (event.target.matches('#CartForm input[name="updates[]"]')) {
      const hint = document.querySelector('[data-cart-update-hint]');
      if (hint) hint.hidden = false;
    }
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('.mobile-nav[open]').forEach(menu => {
      menu.removeAttribute('open'); menu.querySelector('summary').focus();
    });
  });
  document.addEventListener('shopify:section:load', event => init(event.target));
  init();
})();
